<div class="value-block">
  <select2 (valueChanged)="onTypeChange($event)" [value]="selectedOption" [data]="data" [options]="options"></select2>
  <div class="values">
    <input (ngModelChange)="onValueChange($event)"
           (beforeinput)="blockIfInvalid($event)"
           [placeholder]="(isRange ? 'SHARED.Min_value' : '') | translate" type="text"
           (blur)="validateAndCorrect()"
           [(ngModel)]="minValue">
    <input (ngModelChange)="onValueChange($event, false)"
           (beforeinput)="blockIfInvalid($event)"
           (blur)="validateAndCorrect('max')"
           [placeholder]="'SHARED.Max_value' | translate"
           type="text"
           [(ngModel)]="maxValue" *ngIf="isRange">
  </div>
</div>
